import { FC } from "react";
import classNames from "classnames";
import { DsquaresLogoMark } from "src/assets/Icons";

type Props = {
  isLoading: boolean;
};
const SplashScreen: FC<Props> = ({ isLoading }) => {
  return <DsquaresLogoMark className={classNames(isLoading && "animate-pulse")} />;
};

export default SplashScreen;
